<!-- <button class="btn btn-outline-primary" (click)="fill()">Test fill</button> -->

<form [formGroup]="requestForm" novalidate>
    <div class="req-form">
        <h4>Contact Information</h4>
        <div class="form-group">
            <label for="firstName" class="control-label">First Name<span class="req-field"> * </span></label>
            <input id="firstName" type="text" class="form-control" formControlName="firstName">
            <div *ngIf="f.firstName.invalid && (f.firstName.dirty || f.firstName.touched)"
                class="form-text text-danger">
                <div *ngIf="f.firstName.errors.required">First Name is required.</div>
                <div *ngIf="f.firstName.errors.maxlength">Exceeds maximum length limit</div>
            </div>
        </div>
        <div class="form-group">
            <label for="lastName" class="control-label">Last Name<span class="req-field"> * </span></label>
            <input id="lastName" type="text" class="form-control" formControlName="lastName">
            <div *ngIf="f.lastName.invalid && (f.lastName.dirty || f.lastName.touched)" class="form-text text-danger">
                <div *ngIf="f.lastName.errors.required">Last Name is required.</div>
                <div *ngIf="f.lastName.errors.maxlength">Exceeds maximum length limit</div>
            </div>
        </div>
        <div class="form-group">
            <label for="organization" class="control-label">Organization</label>
            <input id="organization" type="text" class="form-control" formControlName="organization">
            <div *ngIf="f.organization.invalid && (f.organization.dirty || f.organization.touched)"
                class="form-text text-danger">
                <div *ngIf="f.organization.errors.maxlength">Exceeds maximum length limit</div>
            </div>
        </div>
        <div class="form-group">
            <label for="email" class="control-label">Email<span class="req-field"> * </span>
                <span style="font-weight: normal;font-size: smaller;"> (NOTE: we rely on email for all communication
                    regarding your application)</span></label>
            <input id="email" type="text" class="form-control" formControlName="email">
            <div *ngIf="f.email.invalid && (f.email.dirty || f.email.touched)" class="form-text text-danger">
                <div *ngIf="f.email.errors.required">Email is required.</div>
                <div *ngIf="f.email.errors.email">Invalid email address</div>
                <div *ngIf="f.email.errors.maxlength">Exceeds maximum length limit</div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-8">
                <div class="form-group">
                    <label for="primaryPhone" class="control-label">Primary Phone<span class="req-field"> *
                        </span></label>
                    <input id="primaryPhone" type="text" class="form-control" formControlName="primaryPhone"
                        appPhoneMask>
                    <div *ngIf="f.primaryPhone.invalid && (f.primaryPhone.dirty || f.primaryPhone.touched)"
                        class="form-text text-danger">
                        <div *ngIf="f.primaryPhone.errors.required">Primary Phone is required.</div>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label for="primaryPhoneType" class="control-label">Phone Type:<span class="req-field"> *
                        </span></label>
                    <select class="form-control" id="primaryPhoneType" formControlName="primaryPhoneType">
                        <option style="display:none">
                        <option *ngFor="let type of phoneTypes" [ngValue]="type">{{type}}</option>
                    </select>
                    <div *ngIf="f.primaryPhoneType.invalid && (f.primaryPhoneType.dirty || f.primaryPhoneType.touched)"
                        class="form-text text-danger">
                        <div *ngIf="f.primaryPhoneType.errors.required">Primary Phone Type is required.</div>
                    </div>
                </div>
            </div>
        </div>


        <div class="row">
            <div class="col-md-8">
                <div class="form-group">
                    <label for="alternativePhone" class="control-label">Alternative Phone</label>
                    <input id="alternativePhone" type="text" class="form-control" formControlName="alternativePhone"
                        appPhoneMask (keyup)="altPhoneClick()">
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label for="alternativePhoneType" class="control-label">Phone Type:</label>
                    <select class="form-control" id="alternativePhoneType" formControlName="alternativePhoneType"
                        [attr.disabled]="f.alternativePhone.value ? null: true">
                        <option style="display:none">
                        <option *ngFor="let type of phoneTypes" [ngValue]="type">{{type}}</option>
                    </select>
                    <div *ngIf="f.alternativePhoneType.invalid && (f.alternativePhoneType.dirty || f.alternativePhoneType.touched)"
                        class="form-text text-danger">
                        <div *ngIf="f.alternativePhoneType.errors.required">alternative Phone Type is required.</div>
                    </div>
                </div>
            </div>
        </div>


        <div class="form-group">
            <label for="mailAddress" class="control-label">Mailing Address<span class="req-field"> *
                </span></label>
            <input id="typeahead-http" type="text" class="form-control" formControlName="mailAddress"
                [ngbTypeahead]="lookupAddress" placeholder="Address search"
                [inputFormatter]="formatter" [resultFormatter]="formatterr" (selectItem)="selectAddress($event)" />
            <div *ngIf="f.mailAddress.invalid && (f.mailAddress.dirty || f.mailAddress.touched)"
                class="form-text text-danger">
                <div *ngIf="f.mailAddress.errors.required">Mail Address is required.</div>
                <div *ngIf="f.mailAddress.errors.maxlength">Exceeds maximum length limit</div>
            </div>
        </div>
        <!-- <div class="form-group">
            <label for="mailAddress" class="control-label">Mailing Address<span class="req-field"> * </span></label>
            <div id='searchBoxContainer'>
                <input id="mailAddress" type="text" class="form-control" formControlName="mailAddress"
                    autocomplete="chrome-off">
            </div>
            <div *ngIf="f.mailAddress.invalid && (f.mailAddress.dirty || f.mailAddress.touched)"
                class="form-text text-danger">
                <div *ngIf="f.mailAddress.errors.required">Mail Address is required.</div>
                <div *ngIf="f.mailAddress.errors.maxlength">Exceeds maximum length limit</div>
            </div>
        </div> -->
        <div class="row">
            <div class="col-md-6 ">
                <div class="form-group">
                    <label for="mailCity" class="control-label">City<span class="req-field"> * </span></label>
                    <input id="mailCity" type="text" class="form-control" formControlName="mailCity">
                    <div *ngIf="f.mailCity.invalid && (f.mailCity.dirty || f.mailCity.touched)"
                        class="form-text text-danger">
                        <div *ngIf="f.mailCity.errors.required">Mail City is required.</div>
                        <div *ngIf="f.mailCity.errors.maxlength">Exceeds maximum length limit</div>
                    </div>
                </div>
            </div>
            <div class="col-md-3 ">
                <div class="form-group">
                    <label for="mailState" class="control-label">State<span class="req-field"> * </span></label>
                    <select class="form-control" id="mailState" formControlName="mailState">
                        <option style="display:none">
                        <option *ngFor="let s of logic.stateLabelValues" [ngValue]="s.label">{{s.value}}</option>
                    </select>
                    <div *ngIf="f.mailState.invalid && (f.mailState.dirty || f.mailState.touched)"
                        class="form-text text-danger">
                        <div *ngIf="f.mailState.errors.required">Mail State is required.</div>
                    </div>
                </div>
            </div>
            <div class="col-md-3 ">
                <div class="form-group">
                    <label for="mailZip" class="control-label">Zip<span class="req-field"> * </span></label>
                    <input id="mailZip" type="text" class="form-control" formControlName="mailZip" [appDigitMask]="5">
                    <div *ngIf="f.mailZip.invalid && (f.mailZip.dirty || f.mailZip.touched)"
                        class="form-text text-danger">
                        <div *ngIf="f.mailZip.errors.required">Zip is required.</div>
                        <div *ngIf="f.mailZip.errors.minlength">Must be 5 digits.</div>
                    </div>
                </div>
            </div>
        </div>
        <h4>Planting Address</h4>
        <div class="form-group">
            <div class="form-check">
                <input id="sameAsMail" type="checkbox" class="form-check-input" formControlName="sameAsMail">
                <label class="form-check-label" for="sameAsMail">The same as mailing address</label>
            </div>
        </div>
        <div class="form-group">
            <label for="plantingAddress" class="control-label">Planting Address<span class="req-field"> *
                </span></label>
            <input id="plantingAddress" type="text" class="form-control" formControlName="plantingAddress"
                [ngbTypeahead]="lookupAddress" placeholder="Planting Address search"
                [inputFormatter]="formatter" [resultFormatter]="formatterr" (selectItem)="selectAddress2($event)" />
            <div *ngIf="f.plantingAddress.invalid && (f.plantingAddress.dirty || f.plantingAddress.touched)"
                class="form-text text-danger">
                <div *ngIf="f.plantingAddress.errors.required">Planting Address is required.</div>
                <div *ngIf="f.plantingAddress.errors.maxlength">Exceeds maximum length limit</div>
            </div>
        </div>
        <!-- <div id='searchBoxContainer2'>
            <div class="form-group">
                <label for="plantingAddress" class="control-label">Planting Address<span class="req-field"> *
                    </span></label>
                <input id="plantingAddress" type="text" class="form-control" formControlName="plantingAddress"
                    autocomplete="chrome-off" [attr.disabled]="f.sameAsMail.value ? true : null">
                <div *ngIf="f.plantingAddress.invalid && (f.plantingAddress.dirty || f.plantingAddress.touched)"
                    class="form-text text-danger">
                    <div *ngIf="f.plantingAddress.errors.required">Planting Address is required.</div>
                    <div *ngIf="f.plantingAddress.errors.maxlength">Exceeds maximum length limit</div>
                </div>
            </div>
        </div> -->
        <div class="row">
            <div class="col-md-6 ">
                <div class="form-group">
                    <label for="plantingCity" class="control-label">City<span class="req-field"> *
                        </span></label>
                    <input id="plantingCity" type="text" class="form-control" formControlName="plantingCity"
                        [attr.disabled]="f.sameAsMail.value ? true : null">
                    <div *ngIf="f.plantingCity.invalid && (f.plantingCity.dirty || f.plantingCity.touched)"
                        class="form-text text-danger">
                        <div *ngIf="f.plantingCity.errors.required">Planting City is required.</div>
                        <div *ngIf="f.plantingCity.errors.maxlength">Exceeds maximum length limit</div>
                    </div>
                </div>
            </div>
            <div class="col-md-3 ">
                <div class="form-group">
                    <label for="plantingState" class="control-label">State<span class="req-field"> * </span></label>
                    <select class="form-control" id="plantingState" formControlName="plantingState"
                        [attr.disabled]="f.sameAsMail.value ? true : null">
                        <option style="display:none">
                        <option *ngFor="let s of logic.stateLabelValues" [ngValue]="s.label">{{s.value}}</option>
                    </select>
                    <div *ngIf="f.plantingState.invalid && (f.plantingState.dirty || f.plantingState.touched)"
                        class="form-text text-danger">
                        <div *ngIf="f.plantingState.errors.required">Planting State is required.</div>
                    </div>
                </div>
            </div>
            <div class="col-md-3 ">
                <div class="form-group">
                    <label for="plantingZip" class="control-label">Zip<span class="req-field"> * </span></label>
                    <input id="plantingZip" type="text" class="form-control" formControlName="plantingZip"
                        [attr.disabled]="f.sameAsMail.value ? true : null" [appDigitMask]="5">
                    <div *ngIf="f.plantingZip.invalid && (f.plantingZip.dirty || f.plantingZip.touched)"
                        class="form-text text-danger">
                        <div *ngIf="f.plantingZip.errors.required">Zip is required.</div>
                        <div *ngIf="f.plantingZip.errors.minlength">Must be 5 didits.</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group">
            <button type="button" class="btn btn-warning" (click)="getNeigGeo()" style="margin-bottom: 15px;"
                [ngClass]="{'asdis' : !isVerifyEnabled}">
                Click here to
                verify your Neighborhood</button>
            <!-- <label for="neighborhoodDesc" class="control-label">Neighborhood</label> -->
            <input id="neighborhood" [value]="request.neighborhoodDesc" type="text" class="form-control" readonly>
            <div style="color: red;">{{neigMess}}</div>
        </div>
 <div *ngIf="request.displayTreeship">
            <div class="form-group">
                <div class="form-check">
                    <input id="neededTreeship" type="checkbox" class="form-check-input"
                        formControlName="neededTreeship">
                    <label class="form-check-label" for="neededTreeship">I need financial assistance, I am applying for
                        a
                        Treeship/ Necesito ayuda financiera, estoy solicitando una beca Treeship.</label>
                </div>

            </div>
            <p>
                The Park People believes that financial constraints shouldn't prevent anyone from planting and enjoying
                the benefits of trees! If you are experiencing economic hardship, check this box to request trees free
                of charge. </p>
            <p>
                The Park People cree que las limitaciones económicas no deberían impedir que nadie plante árboles
                y disfrute de sus beneficios!
                Si atraviesa dificultades económicas, marque esta casilla para solicitar árboles de forma gratuita.
            </p>
            <p>
                Treeships are made possible by the generous donations of others! If you'd like to support the Denver
                tree canopy, please consider adding a donation when you submit your application.
            </p>
            <!-- <div class="form-group">
                <div class="form-check">
                    <input id="neededTreeship" type="checkbox" class="form-check-input"
                        formControlName="neededTreeship">
                    <label class="form-check-label" for="neededTreeship">Yes, I need a Treeship</label>
                </div>
                <div style="margin: 10px;margin-bottom: 40px;">
                    <p>
                        The Park People believes that financial constraints shouldn't prevent anyone from planting and
                        enjoying the benefits of trees! If you are experiencing economic hardship, check this box to
                        receive trees free of charge
                    </p>
                    <p>
                        A written explanation of need is required and will be reviewed prior to approval
                    </p>
                    <p>
                        Treeships are made possible by the generous donations of others! If you'd like to support the
                        Denver tree canopy, please consider adding a donation to your order on a subsequent page
                    </p>
                </div>
            </div> -->
        </div>
        <div class="form-group" *ngIf="requestForm.controls.neededTreeship.value">
            <div>
                <span class="mt-4">
                    Treeships are reviewed and awarded on a rolling basis. To apply, please provide a short explanation
                    of your financial hardship.<span class="req-field"> * </span>
                </span>
                <p class="mt-1">
                    Las ayudas Treeships se revisan y conceden de forma continua.
                    Para solicitarla, proporcione una breve explicación de sus dificultades económicas.
                    <span class="req-field"> * </span>
                 </p>
            </div>
            <textarea id="ifTreeshipParagraph" rows="4" type="text" class="form-control"
                formControlName="ifTreeshipParagraph"></textarea>
            <div *ngIf="f.ifTreeshipParagraph.invalid && (f.ifTreeshipParagraph.dirty || f.ifTreeshipParagraph.touched)"
                class="form-text text-danger">
                <div *ngIf="f.ifTreeshipParagraph.errors.required">Planting Treeship Paragraph is required.</div>
            </div>
        </div>
    </div>
</form>
<!-- <h1>Same Form as Inline (Horizontal)</h1>

<form [formGroup]="requestForm" novalidate>
    <div class="req-form">
        <h4>Contact</h4>
        <div class="form-group row">
            <label for="firstName" class="col-sm-4 col-md-3 col-form-label text-sm-right">First Name<span
                    class="req-field"> * </span></label>
            <div class="col-sm-8 col-md-9">

                <input id="firstName" type="text" class="form-control" formControlName="firstName">
                <div *ngIf="f.firstName.invalid && (f.firstName.dirty || f.firstName.touched)"
                    class="form-text text-danger">
                    <div *ngIf="f.firstName.errors.required">First Name is required.</div>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label for="lastName" class="col-sm-4 col-md-3 col-form-label text-sm-right">Last Name<span
                    class="req-field"> * </span></label>
            <div class="col-sm-8 col-md-9">
                <input id="lastName" type="text" class="form-control" formControlName="lastName">
                <div *ngIf="f.lastName.invalid && (f.lastName.dirty || f.lastName.touched)"
                    class="form-text text-danger">
                    <div *ngIf="f.lastName.errors.required">Last Name is required.</div>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label for="organization" class="col-sm-4 col-md-3 col-form-label text-sm-right">Organization</label>
            <div class="col-sm-8 col-md-9">
                <input id="organization" type="text" class="form-control" formControlName="organization">
            </div>
        </div>
        <div class="form-group row">
            <label for="email" class="col-sm-4 col-md-3 col-form-label text-sm-right">Email<span class="req-field"> *
                </span></label>
            <div class="col-sm-8 col-md-9">
                <input id="email" type="text" class="form-control" formControlName="email">
                <div *ngIf="f.email.invalid && (f.email.dirty || f.email.touched)" class="form-text text-danger">
                    <div *ngIf="f.email.errors.required">Email is required.</div>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label for="primaryPhone" class="col-sm-4 col-md-3 col-form-label text-sm-right">Primary Phone<span
                    class="req-field"> * </span></label>
            <div class="col-sm-8 col-md-9">
                <input id="primaryPhone" type="text" class="form-control" formControlName="primaryPhone">
                <div *ngIf="f.primaryPhone.invalid && (f.primaryPhone.dirty || f.primaryPhone.touched)"
                    class="form-text text-danger">
                    <div *ngIf="f.primaryPhone.errors.required">Primary Phone is required.</div>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label for="alternativePhone" class="col-sm-4 col-md-3 col-form-label text-sm-right">Alternative
                Phone</label>
            <div class="col-sm-8 col-md-9">
                <input id="alternativePhone" type="text" class="form-control" formControlName="alternativePhone">
            </div>
        </div>
        <div class="form-group row">
            <label for="mailAddress" class="col-sm-4 col-md-3 col-form-label text-sm-right">Mail Address</label>
            <div class="col-sm-8 col-md-9">
                <input id="mailAddress" type="text" class="form-control" formControlName="mailAddress">
                <div *ngIf="f.mailAddress.invalid && (f.mailAddress.dirty || f.mailAddress.touched)"
                    class="form-text text-danger">
                    <div *ngIf="f.mailAddress.errors.required">Mail Address is required.</div>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label for="mailCity" class="col-sm-4 col-md-3 col-form-label text-sm-right">Mail City</label>
            <div class="col-sm-8 col-md-9">
                <div class="row">
                    <div class="col-sm-7">
                        <input id="mailCity" type="text" class="form-control" formControlName="mailCity">
                        <div *ngIf="f.mailCity.invalid && (f.mailCity.dirty || f.mailCity.touched)"
                            class="form-text text-danger">
                            <div *ngIf="f.mailCity.errors.required">Mail City is required.</div>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <input id="mailState" type="text" class="form-control" formControlName="mailState"
                            placeholder="State">
                        <div *ngIf="f.mailState.invalid && (f.mailState.dirty || f.mailState.touched)"
                            class="form-text text-danger">
                            <div *ngIf="f.mailState.errors.required">Mail State is required.</div>
                        </div>
                    </div>
                    <div class="col-sm-4 col-md-3">
                        <input id="mailZip" type="text" class="form-control" formControlName="mailZip"
                            placeholder="Zip">
                        <div *ngIf="f.mailZip.invalid && (f.mailZip.dirty || f.mailZip.touched)"
                            class="form-text text-danger">
                            <div *ngIf="f.mailZip.errors.required">Mail Zip is required.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <h4>Planting</h4>
        <div class="form-group row">
            <label for="plantingAddress" class="col-sm-4 col-md-3 col-form-label text-sm-right">Planting Address</label>
            <div class="col-sm-8 col-md-9">
                <input id="plantingAddress" type="text" class="form-control" formControlName="plantingAddress">
                <div *ngIf="f.plantingAddress.invalid && (f.plantingAddress.dirty || f.plantingAddress.touched)"
                    class="form-text text-danger">
                    <div *ngIf="f.plantingAddress.errors.required">Planting Address is required.</div>
                </div>
            </div>
        </div>

        <div class="form-group row">
            <label for="mailCity" class="col-sm-4 col-md-3 col-form-label text-sm-right">Mail City</label>
            <div class="col-sm-8 col-md-9">
                <div class="row">
                    <div class="col-sm-7">
                        <input id="plantingCity" type="text" class="form-control" formControlName="plantingCity">
                        <div *ngIf="f.plantingCity.invalid && (f.plantingCity.dirty || f.plantingCity.touched)"
                            class="form-text text-danger">
                            <div *ngIf="f.plantingCity.errors.required">Planting City is required.</div>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <input id="plantingState" type="text" class="form-control" formControlName="plantingState"
                            placeholder="State">
                        <div *ngIf="f.plantingState.invalid && (f.plantingState.dirty || f.plantingState.touched)"
                            class="form-text text-danger">
                            <div *ngIf="f.plantingState.errors.required">Planting State is required.</div>
                        </div>
                    </div>
                    <div class="col-sm-4 col-md-3">
                        <input id="plantingZip" type="text" class="form-control" formControlName="plantingZip"
                            placeholder="Zip">
                        <div *ngIf="f.plantingZip.invalid && (f.plantingZip.dirty || f.plantingZip.touched)"
                            class="form-text text-danger">
                            <div *ngIf="f.plantingZip.errors.required">Planting Zip is required.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="form-group row">
            <label for="neighborhoodId" class="col-sm-4 col-md-3 col-form-label text-sm-right">Neighborhood</label>
            <div class="col-sm-8 col-md-9">
                <input id="neighborhood" type="text" class="form-control">
            </div>
        </div>
        <div class="col-sm-8 col-md-9 offset-sm-4 offset-md-3">
            <div class="form-check">
                <input id="neededTreeship" type="checkbox" class="form-check-input" formControlName="neededTreeship">
                <label class="form-check-label" for="neededTreeship">Yes, I need a Treeship</label>
            </div>
        </div>
        <div class="form-group row">
            <label for="ifTreeshipParagraph" class="col-sm-4 col-md-3 col-form-label text-sm-right">If Treeship
                Paragraph</label>
            <div class="col-sm-8 col-md-9">
                <textarea id="ifTreeshipParagraph" type="text" rows="5" class="form-control"
                    formControlName="ifTreeshipParagraph"></textarea>
            </div>
        </div>
    </div>
</form> -->
<div class="req-form">
    <div *ngFor="let control of udfForms.controls; index as i">
        <div *ngIf="udfs[i].uDFIControlType==='Header'">
            <h5>{{udfs[i].uDFTitle}}</h5>
        </div>
        <div *ngIf="udfs[i].uDFIControlType==='HTML'">
            <div [innerHTML]="udfs[i].uDFThisHTMLOnly"></div>
        </div>

        <div class="form-group" *ngIf="udfs[i].uDFIControlType==='Textbox'">
            <label for="value{{i}}" class="control-label">{{udfs[i].uDFTitle}}<span class="req-field"
                    *ngIf="udfs[i].uDFIsRequired"> * </span></label>
            <input id="value{{i}}" type="text" class="form-control" [formControl]="udfForms.controls[i]">
            <div *ngIf="udfForms.controls[i].invalid && (udfForms.controls[i].dirty || udfForms.controls[i].touched)"
                class="form-text text-danger">
                <div *ngIf="udfForms.controls[i].errors.required">This Answer is required.</div>
            </div>
        </div>
        <div class="form-group" *ngIf="udfs[i].uDFIControlType==='Check Box'">
            <div class="form-check">
                <input id="value{{i}}" type="checkbox" class="form-check-input" [formControl]="udfForms.controls[i]">
                <label class="form-check-label" for="value{{i}}">{{udfs[i].uDFTitle}}</label>
            </div>
        </div>
        <!-- <div class="form-group" *ngIf="udfs[i].uDFIControlType==='Check Box'">
            <div class="form-check">
                <input id="value{{i}}" type="checkbox" class="form-check-input" [formControl]="udfForms.controls[i]">
                <label class="form-check-label" for="value{{i}}">{{udfs[i].uDFTitle}}</label>
            </div>
        </div> -->
        <div class="form-group" *ngIf="udfs[i].uDFIControlType==='Dropdown'">
            <label for="value{{i}}" class="control-label">{{udfs[i].uDFTitle}}<span class="req-field"
                    *ngIf="udfs[i].uDFIsRequired"> * </span></label>
            <select class="form-control" id="transType" [formControl]="udfForms.controls[i]">
                <option value style="display:none">
                <option *ngFor="let q of udfDrops(i)" [ngValue]="q">{{q}}</option>
            </select>
            <div *ngIf="udfForms.controls[i].invalid && (udfForms.controls[i].dirty || udfForms.controls[i].touched)"
                class="form-text text-danger">
                <div *ngIf="udfForms.controls[i].errors.required">This Answer is required.</div>
            </div>
        </div>

        <!-- <input [formControl]="udfForms.controls[i]" /> -->
    </div>
</div>